export const LEADERBOARD_TYPES = {
  LOCATION: "location",
  COMPANY: "company",
  INDUSTRY: "vertical",
};

export const FEED_SCROLL_POSITION_STORAGE_KEY =
  "spiffy-feed-scroll-position-Z88JB1";

export const MODULE_TYPES = {
  ALL: "all",
  ASSIGNED: "assigned",
  EXTRA_CREDIT: "extraCredit",
};

export const ERROR_CODES = {
  ALREADY_COMPLETED: "already_completed",
  LOCKED_OUT: "module_locked_out",
};

export const AMPLITUDE_CODES = {
  MODULE_STARTED_NEXT_MOD_BTN: "Module Started [Next Module Button]",
  MODULE_STARTED_CARD: "Module Started [Module Card]",
  CERT_MODULE_STARTED_CARD: "Certification Moudle Started [Module Card]",
  LOGIN: "Successful Log In",
  REGISTER_WITH_TEAM: "Account Registered [With Team]",
  REGISTER_CREATE_TEAM: "Account Registered [Created Team]",
  REGISTER_QR_CODE_LOCATION: "Account Registered [QR CODE LOCATION]",
};

export const SNACK_TYPES = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
};
